<div
  class="deal-status-display tw-whitespace-nowrap tw-grid tw-grid-flow-col tw-align-middle tw-text-center">
  <button 
    mat-flat-button 
    data-cy="deal-status-display-current"
    [ngClass]="{
      'tw-opacity-60' : deal.stage === 'funded' && (deal.status !== 'current'),
      'bg-offer-received' : deal.status === 'offerReceived'
    }"
    class="bg-{{deal.stage}}"
    [matTooltip]="'Contact Funding Desk to change status'"
    [matTooltipDisabled]="!(canSeeDealStatusRestrictions$ | async)"
  >
    {{ statusFormatted }}
  </button>
</div>
